import React, {Component} from 'react';
import '../../Home.css';

let _this;

class SigmaSpeaksProduct extends Component {

    constructor(props, context) {
        super(props);
        _this = this;

    }

    componentDidMount() {
    }

    render() {
        return <div className="container">
            <div align="center">
                <div className="fast_nav container">
                    <ul>
                        <li className="first">
                            <a href="#" role="button"
                               onClick={() => _this.props.navigate('Products')}>2025 © AnswerSolutions LLC</a>
                        </li>
                        <li className="selected">
                            <a href="#sigma-speaks-product" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksProduct')}>Sigma Speaks</a>
                        </li>
                        <li>
                            <a href="#sigmaspeakspolicy" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksPolicy')}>Privacy Policy</a>
                        </li>
                        <li>
                            <a href="#sigmaspeakseula" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksEULA')}>User Agreement</a>
                        </li>
                        <li>
                            <a href="#sigmaspeaksSupport" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksSupport')}>Support</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card" id="shell4">
                <div id="card_content">
                    <div>
                        <img style={{borderRadius: '10%', margin: '0 16px 0 16px'}}
                             className="roundrect"
                             src="/sigma_speaks_artwork.png"
                             align="left"
                             alt="app icon"
                             width="128"/>
                        <div>
                            <h2>Sigma Speaks: Audio News Daily</h2>
                            <h3>Tailored for Retail Investors</h3>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <p>
                        <b>Why you need Sigma Speaks?</b><br/><br/>
                        Sigma Speaks is an audio-first news app that fetches the latest market stories each morning and turns them into spoken summaries. The app plays articles one by one, automatically using high-quality audio when available or falling back to the device’s built-in TTS engine.

                        Users can bookmark articles for later, skip any story, or open the original publication directly from the app.

                        This version focuses on core playback and navigation features—personalization and scheduling will come in future updates.
                    </p>
                    <div className="row">
                        <div className="column">
                            <img src="/ss1.png" alt="screenshot 1" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/ss2.png" alt="screenshot 2" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/ss3.png" alt="screenshot 3" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/ss4.png" alt="screenshot 4" width="100%"/>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <div className="divider"></div>
                <div style={{margin: '0 24px 0 24px'}}>
                    <b>Legal & Copyright Notice</b>
                    <p>Sigma Speaks is committed to respecting intellectual property rights. All original sources are mentioned in the commentaries-summaries and the original articles can be opened in one tap.</p>
                </div>
                <div className="divider"></div>
                <br/>
                <div style={{margin: '0 24px 0 24px'}}>
                    <h4>Listen on Spotify and Apple Podcast</h4>
                </div>
                <div className="product-links" style={{margin: '16px 0 0 16px'}}>
                    <a href="https://open.spotify.com/show/7hz2cM5DfbbTv26ppMbfdR?si=7a50597451e14345"
                       target="_blank"
                       rel="noopener">
                        <img src="/spotify-podcast.png" alt="listen on spotify" height="36" hspace="5" vspace="5"/>
                    </a>
                    <a href="https://podcasts.apple.com/us/podcast/sigma-speaks/id1851266467"
                       target="_blank"
                       rel="noopener">
                        <img src="/apple_podcasts_b.svg" alt="listen on apple podcast" height="36" hspace="5" vspace="5"/>
                    </a>
                </div>
                <div className="divider"></div>
                <br/>
                <div style={{margin: '0 24px 0 24px'}}>
                    <h4>WORKS ON IPHONE AND ANDROID (Beta access)</h4>
                </div>
                <br/>
                <div align="center" hspace="10" vspace="10">
                    <a href="https://testflight.apple.com/join/kzNZGq4A"
                       target="_blank"
                       rel="noopener">
                        <img src="/app_store.png" alt="itunes" height="36" hspace="5" vspace="5"/>
                    </a>
                    <a href="https://play.google.com/apps/testing/com.answersolutions.sigmaspeak"
                       target="_blank"
                       rel="noopener">
                        <img src="/google_play.svg" alt="google play" height="36" hspace="5" vspace="5"/>
                    </a>
                </div>
            </div>
            <div align="center">
                <div className="fast_nav container">
                    <ul>
                        <li className="first">
                            <a href="#" role="button"
                               onClick={() => _this.props.navigate('Products')}>2025 © AnswerSolutions LLC</a>
                        </li>
                        <li className="selected">
                            <a href="#sigma-speaks-product" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksProduct')}>Sigma Speaks</a>
                        </li>
                        <li>
                            <a href="#sigmaspeakspolicy" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksPolicy')}>Privacy Policy</a>
                        </li>
                        <li>
                            <a href="#sigmaspeakseula" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksEULA')}>User Agreement</a>
                        </li>
                        <li>
                            <a href="#sigmaspeaksSupport" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksSupport')}>Support</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    }
}

export default SigmaSpeaksProduct;